import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

export const isPhoneNumberValid = (phone: string): boolean => {
  try {
    const number = phoneUtil.parse(phone);
    return phoneUtil.isValidNumber(number);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
};

export const VALIDATE = {
  phoneNumber: isPhoneNumberValid,
};
